
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-161abd0f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./createOrUpdateConversation.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./createOrUpdateConversation.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-161abd0f\",\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./createOrUpdateConversation.vue"),
  /* scopeId */
  "data-v-161abd0f",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/conversation/createOrUpdateConversation.vue
// module id = /8Uq
// module chunks = 1